<gplus-header [attr.data-vef]="'header-content'" />

<div class="content-wrapper">
  <cw-navigation-rail
    class="navigation-rail"
    [class.hide]="statusService.status()?.id === status.APP_UNAVAILABLE || navigationItems()?.length === 0"
  >
    @for (item of navigationItems(); track item.routerLink) {
      <cw-navigation-rail-item
        routerLinkActive="active"
        [routerLink]="item.routerLink"
        queryParamsHandling="merge"
        [name]="item.labelKey | translate"
        [icon]="item.icon"
        font="cortex"
        [disabled]="item.disabled"
        (click)="$event.stopPropagation(); linkClicked()"
      />
    }
  </cw-navigation-rail>

  @if (headerService.toggleMobileMenu()) {
    <gplus-mobile-drawer class="gplus-mobile-drawer" />
  }

  <div class="router-wrapper">
    <router-outlet />
  </div>
</div>
<gplus-modal-container [dialog]="dialogService.dialog()" />
<gplus-overlay [overlay]="overlayService.overlay()" />
<gplus-sidebar-container [sidebar]="sidebarService.sidebar()" />
<gplus-toast-container [toast]="toastService.toast()" />

<!--  Temporarily solution to load material font to prevent FOUC: Flash of Unstyled Content
 -->
<cw-icon class="no-visible" icon="home" size="xxs" filled="false" font="material"></cw-icon>
